import script from "./LichessChallengeView.vue?vue&type=script&setup=true&lang=js"
export * from "./LichessChallengeView.vue?vue&type=script&setup=true&lang=js"

import "./LichessChallengeView.vue?vue&type=style&index=0&id=f9441722&scoped=true&lang=css"

import exportComponent from "/Users/henry/ionic/verbalchess_ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9441722"]])

export default __exports__